module.exports = __webpack_public_path__ + "img/hui.2957105e.png";